import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

const supportedLanguages = ['en', 'de', 'fr', 'ar', 'zh', 'hi', 'id', 'fa', 'pt', 'ru', 'es', 'th', 'tr', 'vi'] as const
export type Language = typeof supportedLanguages[number];

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public static readonly LANGUAGE_COOKIE_IDENTIFIER = 'LANGUAGE';

  private readonly language: Language;

  constructor(
    private cookieService: CookieService
  ) {
    this.language = this.findInitialLanguage();
  }

  public getLanguage(): Language {
    return this.language;
  }

  public findInitialLanguage(): Language {
    if (this.hasLanguageInCookie()) {
      return this.getLanguageFromCookie();
    } else {
      return 'de';
    }
  }

  public saveLastLanguage(language: Language): void {
    this.cookieService.set(LanguageService.LANGUAGE_COOKIE_IDENTIFIER, language, undefined, '/');
  }

  private getLanguageFromCookie(): Language {
    const language=this.cookieService.get(LanguageService.LANGUAGE_COOKIE_IDENTIFIER);
    if(supportedLanguages.findIndex((supportedLang)=>supportedLang===language)>-1){
      return language as Language;
    }
    if(language === 'in'){
      return 'id';
    }
    return 'de';
  }

  private hasLanguageInCookie(): boolean {
    return this.cookieService.check(LanguageService.LANGUAGE_COOKIE_IDENTIFIER);
  }

}
